import { RoadmapData } from "../../../hooks/useApiCalls";
import ItemBox from "./components/ItemBox";

 

function Roadmap() {

    const roadmap = RoadmapData();
    let rmap = roadmap ? roadmap : [];

    return ( 
       <>
        <section id="roadmap" className="py-5">
            <div className="container">
            <h2 className="text-center mb-5">Roadmap</h2>
            <div className="timeline">
                {Array.isArray(rmap) && rmap.map((data)=>{
                    return <ItemBox  title={data.title} date={data.time} detail={data.detail} />
                })}
              
            </div>
            </div>
        </section>
    </> 
 ); 

}

export default Roadmap;